import { TaskKind } from "@/generated/graphql";

/**
 * Return the TaskKind prefix used to distinguish sub-task pages of an
 * assessment (e.g. "Group Work — "). Empty string when the kind has no prefix.
 *
 * @param taskKind - The kind of the task (Group, Individual, or Peer).
 * @return The prefix string, including its trailing separator.
 */
export function formatTaskKindPrefix(taskKind?: TaskKind): string {
  if (taskKind === TaskKind.Group) {
    return "Group Work — ";
  } else if (taskKind === TaskKind.Individual) {
    return "Individual Work — ";
  } else if (taskKind === TaskKind.Peer) {
    return "Peer Evaluation — ";
  }
  return "";
}

/**
 * Return a formatted task title based on the TaskKind.
 *
 * @param assessmentName - The name of the assessment.
 * @param taskKind - The kind of the task (Group, Individual, or Peer).
 * @return A formatted string representing the task title.
 */
export function formatTaskTitle(
  assessmentName?: string,
  taskKind?: TaskKind
): string {
  const prefix = formatTaskKindPrefix(taskKind);
  const suffix = assessmentName ?? "";
  return `${prefix}${suffix}`;
}
